import { ReactNode } from 'react';
import { ErrorPanel } from './ErrorPanel';

export default function Loader(props: {
  loading: boolean;
  showErrorPanel?: boolean;
  errorPanelMessage?: string;
  children: ReactNode;
  loader: ReactNode;
}) {
  if (props.showErrorPanel)
    return <ErrorPanel message={props.errorPanelMessage} />;
  return (
    <>
      {props.loading && props.loader}
      {!props.loading && props.children}
    </>
  );
}
